import Box from '@mui/material/Box';
import Slider, { sliderClasses } from '@mui/material/Slider';
import InputNumber from 'common/components/Elements/Form/InputNumber/InputNumber';
import { arrayTimes } from 'common/utilities/core/array';
import { stringIsNumber } from 'common/utilities/core/string';
import { sxSubClassName } from 'core/utilities/theme';
import React from 'react';
import type {SelectedColorScheme } from 'sequenceAnalyser/utilities/colors';
import { isConservationMandatoryForSelectedColorScheme } from 'sequenceAnalyser/utilities/colors';

import classes from './ColorsConservation.style';

export const colorsConservationSteps = arrayTimes(11).map((t, i) => ({
  value: i * 10,
  label: [0, 50, 100].includes(i * 10) ? `${i * 10}%` : undefined,
  rangeLabel: (i * 10) === 100 ? '100%' : `${i * 10}-${((i + 1) * 10) - 1}%`,
}));

interface ComponentProps {
  colors: SelectedColorScheme;
  onConservationChange: (value: number) => void;
}

function ColorsConservation({
  colors, onConservationChange,
}: ComponentProps) {
  return (
    <Box mt={5.5} mr={2}>
      <InputNumber
        label="Conservation"
        value={colors.conservation.toString()}
        unit="%"
        longFormStyle
        onChange={(value) => {
          if (stringIsNumber(value) && Number(value) > 0) {
            onConservationChange(Number(value) > 100 ? 100 : Number(value));
          } else {
            onConservationChange(0);
          }
        }}
        clearable
        fullWidth
      />
      <Slider
        value={colors.conservation}
        track="inverted"
        getAriaValueText={(value) => `${value}%`}
        step={10}
        min={0}
        max={100}
        valueLabelDisplay="auto"
        marks={colorsConservationSteps}
        onChange={(e, value) => { if (!Array.isArray(value)) onConservationChange(value); }}
        sx={isConservationMandatoryForSelectedColorScheme(colors) ? {
          [sxSubClassName(sliderClasses.rail)]: classes.rail,
          [sxSubClassName(sliderClasses.track)]: classes.track,
          [sxSubClassName(sliderClasses.mark)]: classes.mark,
          [sxSubClassName(sliderClasses.thumb)]: classes.thumb,
          [sxSubClassName(sliderClasses.valueLabel)]: classes.valueLabel,
        } : {}}
      />
    </Box>
  );
}

export default ColorsConservation;
